import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=de7c2c6c&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=de7c2c6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7c2c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de7c2c6c')) {
      api.createRecord('de7c2c6c', component.options)
    } else {
      api.reload('de7c2c6c', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=de7c2c6c&scoped=true&", function () {
      api.rerender('de7c2c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NuHomeCloneProductCarousel/Loader.vue"
export default component.exports